import { useEffect, useRef } from "react";
import Landing from "./Containers/Landing";
import { trackVisit } from "./Services/api";
import "./App.css";

function App() {
  const hasTrackedVisit = useRef(false);

  useEffect(() => {
    // Prevent double tracking in StrictMode
    if (hasTrackedVisit.current) return;
    hasTrackedVisit.current = true;

    // Track visit on app load
    trackVisit();
  }, []);

  return <Landing />;
}

export default App;
